import React, {useCallback, useEffect, useLayoutEffect, useState} from 'react';
import ItemPageStyles from './ItemPage.module.scss';
import SliderItemPage from "../../components/SliderItemPage/SliderItemPage";
import {Link, useNavigate, useParams} from "react-router-dom";
import {useAppDispatch, useAppSelector} from "../../utils";
import {clearItem, fetchShopItem} from "../../services/slices/ShopSlice";
import ShopPageStyles from "../ShopPage/ShopPage.module.scss";
import {API_URL_PHOTO} from "../../constants";
import {ItemType, Sizes} from "../../entity/index.entity";
import {addToCart} from "../../services/slices/CartSlice";
import Toast from "../../components/Toast/Toast";

const ItemPage = () => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    const {id} = useParams();
    const {item} = useAppSelector((state) => state.shopSlice);
    const [activeIndex, setActiveIndex] = useState(0);

    const [selectedSize, setSelectedSize] = useState<string | null>(null);
    const [showToast, setShowToast] = useState(false);

    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            if (id) {
                setIsLoading(true);
                try {
                    await dispatch(fetchShopItem(id)).unwrap();
                } finally {
                    setIsLoading(false);
                }
            }
        };

        fetchData();
        return () => {
            dispatch(clearItem());
        };
    }, [id, dispatch]);

    const handleSlideChange = useCallback((index: number) => {
        setActiveIndex(index);
    }, []);

    useEffect(() => {
        if (item && item.sizes.length > 0) {
            const firstAvailableSize = item.sizes.find((size: Sizes) => size.amount !== 0);
            if (firstAvailableSize) {
                setSelectedSize(firstAvailableSize.name);
            }
        }
    }, [item]);

    if (isLoading) {
        return (
            <div className={ItemPageStyles.loadingWrapper}>
                <div className={ItemPageStyles.loadingSpinner}/>
            </div>
        );
    }

    if (!item) return <div className={ItemPageStyles.notFound}>Товар не найден</div>;

    const handleAddToCart = (item: ItemType) => {
        if (selectedSize && item) {
            dispatch(addToCart({item, size: selectedSize}));
            setShowToast(true);
        }
    };

    const handleSizeClick = (size: string) => {
        setSelectedSize(size);
    };

    const handleGoBack = () => {
        navigate(-1);
    };

    const hasOneSize = item.sizes.some((size) => size.name.toLowerCase() === "вансайз");

    return (
        <div className={ItemPageStyles.itemPageWrapper}>
            {showToast && (
                <Toast
                    message={'Товар добавлен в корзину'}
                    onClose={() => setShowToast(false)}
                    status={'success'}
                />
            )}
            <div className={ItemPageStyles.navigation}>
                <div className={ItemPageStyles.arrowWrapper}>
                    <img src="/arrow.svg" alt={'arrow'}/>
                    <p onClick={handleGoBack}>Назад</p>
                </div>
                <Link to={`/`} className={ItemPageStyles.link}>
                    <img src="/close.svg" alt="close"/>
                </Link>
            </div>

            <div className={ItemPageStyles.mainWrapper}>
                <div className={ItemPageStyles.left}>
                    <div className={ItemPageStyles.sliderWrapper}>
                        <SliderItemPage
                            images={item.extra_images}
                            activeIndex={activeIndex}
                            onSlideChange={handleSlideChange}
                        />
                    </div>
                    <div className={ItemPageStyles.items}>
                        {item.extra_images.map((image, index) => (
                            <img
                                key={index}
                                onClick={() => handleSlideChange(index)}
                                className={`${ItemPageStyles.itemPhoto} ${
                                    activeIndex === index ? ItemPageStyles.activeItemPhoto : ''
                                }`}
                                src={API_URL_PHOTO + image}
                                alt={image}
                            />
                        ))}
                    </div>
                </div>
                <div className={ItemPageStyles.right}>
                    <div>
                        <div className={ItemPageStyles.rightTitle}>
                            <p className={ItemPageStyles.nameItem}>{item.name}</p>
                            <p className={ItemPageStyles.priceItem}>{item.price} р.</p>
                        </div>

                        <p className={ItemPageStyles.descriptionItem}>{item.description}</p>
                    </div>

                    <div>
                        <p className={ItemPageStyles.descriptionSizeTitle}>размерчик</p>
                        <div className={ItemPageStyles.sizeList}>
                            {item.sizes.map((size: Sizes, index) => {
                                if (size.name.toLowerCase() === "вансайз") return null;

                                const isNumberRange = size.name.includes('-');
                                const isAvailable = size.amount > 0;

                                return (
                                    <div
                                        key={index}
                                        className={`${ItemPageStyles.sizeItem} 
                                            ${isNumberRange ? ItemPageStyles['sizeItem--range'] : ''} 
                                            ${isAvailable ? ItemPageStyles.available : ItemPageStyles.unavailable}
                                            ${selectedSize === size.name ? ItemPageStyles.selectedSize : ''}
                                        `}
                                        onClick={() => isAvailable && handleSizeClick(size.name)}
                                    >
                                        {size.name}
                                    </div>
                                );
                            })}
                        </div>
                    </div>

                    <div
                        onClick={() => handleAddToCart(item)}
                        className={`${ItemPageStyles.btn} ${
                            !selectedSize && !hasOneSize ? ItemPageStyles.disabledBtn : ''
                        }`}
                    >
                        в корзину
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ItemPage;
